<template>
  <layout-basic>
    <v-container fluid>
      <v-row v-if="$globalConfig.APP_NAME == 'partner'">
        <v-col md="5">
          <v-alert v-model="showAlert" dismissible icon="$error" color="#FFF6E7" class="custom-border"
            variant="outlined"><b>Important:</b> Free trials expire after 14 days. To start using the full version or
            extend your trial, please contact <a href="mailto:hello@improve.online"
              style="text-decoration: underline;">hello@improve.online</a></v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field class="search-box" placeholder="Search Companies" prepend-icon="fa-search" v-model="search"
            type="text" clearable clear-icon="fa-times" @click:clear="resetSearch" @keyup="applySearch"></v-text-field>
        </v-col>
        <v-col cols="12" md="3">

          <v-select :items="status" :clearable="true" placeholder="Status" item-value="id" item-text="name"
            v-on:change="FilterByStatus($event)" class="groups"></v-select>

        </v-col>
        <v-col cols="12" md="6" class="addcustomer-button-wrapper">

          <v-btn class="mr-1 ml-1 btn btn-primary" color="primary" outlined v-on="on" v-if="importCustomer"
            @click="showCustomerImportPanel()">
            {{ $globalConfig.APP_NAME == 'senso' ? 'IMPORT SCHOOLS' : 'IMPORT CUSTOMERS' }}
          </v-btn>
          <v-btn v-if="!userLimit && canCreateCustomer" class="btn btn-primary" color="primary"
            @click.prevent="showCreatePanel()" outlined>
            <v-icon class="pr-2">fa-plus</v-icon>Add Customer
          </v-btn>
          <v-btn v-else class="btn btn-primary" disabled color="primary" @click.prevent="showCreatePanel()" outlined>
            <v-icon class="pr-2">fa-plus</v-icon>Add Customer
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="userLimit">
        <v-col md="12">
          <v-alert type="error">You have reached the maximum number of users for your plan</v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-card-title>
              <div class="flex-grow-1"></div>
            </v-card-title>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table"
              :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table"
              :types="{ 'table-heading': '', 'table-thead': 'heading@1', 'table-row': 'text@1' }"
              class="slider-table"></v-skeleton-loader>
            <v-data-table :headers="computedHeaders" :options.sync="options" :server-items-length="serverItemsLength"
              v-show="!loading" :items="users">
              <template v-slot:item.improve="{ item }">
                <v-switch :disabled="item.company.data.state == 4" @change="
                  item.is_improve_content
                    ? addImproveContent(item.id)
                    : removeContent(item.company_id, item.id, 0)
                  " v-model="item.is_improve_content" :value="item.is_improve_content"></v-switch>
              </template>

              <!-- <template v-slot:item.improve="{ item }">
                            <v-switch @change="showImproveEdifyPopUp(item.id)" :value="true" color="primary"></v-switch>
                        </template>-->

              <template v-slot:item.edify="{ item }">
                <v-switch :disabled="item.company.data.state == 4" @change="
                  item.is_edify_content
                    ? addEdifyContent(item.id)
                    : removeContent(item.company_id, item.id, 1)
                  " v-model="item.is_edify_content" :value="item.is_edify_content"></v-switch>
              </template>

              <!-- Dynamic slots for membership packages -->
              <template v-for="pckg in membershipPackages" v-slot:[`item.${pckg.id}`]="{ item }">
                <v-switch :key="pckg.id" :disabled="item.state == 4" @change="
                  item.membership_package_id.includes(pckg.id)
                    ? addMembershipContent(item.id, item.company_id, pckg.id, pckg.name)
                    : removeContent(item.company_id, item.id, 2, pckg.id, pckg.name)
                  " v-model="item.membership_package_id" :value="pckg.id"></v-switch>
              </template>

              <template v-slot:item.importUsers="{ item }">
                <v-btn :loading="loading" @click="showUserImportPanel">
                  <v-icon dark> mdi-cloud-upload </v-icon>
                </v-btn>
              </template>

              <template v-slot:item.confirmed="{ item }">
                <v-icon v-if="item.confirmed" color="primary">fa-check</v-icon>
                <v-icon v-else color="error">fa-times</v-icon>
              </template>
              <template id="group-icons" v-slot:item.id="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" :disabled="item.company.data.state == 4" :id="item.id" outlined small
                      color="secondary" class="mr-1" @click.prevent="redirectTo('/partner/notification/' + item.company_id)">
                      <v-icon small>fa fa-bell</v-icon>
                    </v-btn>
                  </template>
                  <span>Configure notifications for this company.</span>
                </v-tooltip>
                <v-tooltip bottom v-if="isPartnerLevel || canManagerAccessCustomer">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" color="secondary" class="mr-1" outlined small @click.prevent="
                      processGetFullPlatformReport(
                        item.company_id,
                        $store.getters.user.id
                      )
                      ">
                      <v-img src="/static/improve-full-platform-report.png"></v-img>
                    </v-btn>
                  </template>
                  <span>Full Platform Report</span>
                </v-tooltip>
                <v-tooltip bottom v-if="canCreateCustomer">
                  <template v-slot:activator="{ on }">
                    <v-btn :disabled="item.company.data.state == 4" v-on="on" color="secondary" class="mr-1" outlined
                      small @click.prevent="showCreateClonePanel(item.id, item.company_id)">
                      <v-icon small>fa-solid fa-copy</v-icon>
                    </v-btn>
                  </template>
                  <span>Create Clone Account</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn :disabled="item.company.data.state == 4" :id="item.id" v-on="on" outlined small
                      color="secondary" @click.prevent="showEditPanel(item.id)">
                      <v-icon small>fa-pencil-alt</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit User</span>
                </v-tooltip>
                <!-- State Suspend button -->
                <v-tooltip bottom v-if="item.company.data.state != 4">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" color="error" class="ml-1" outlined small @click.prevent="
                      updateState(item.company.data.id, 'suspend')
                      ">
                      <v-icon small>fa fa-ban</v-icon>
                    </v-btn>
                  </template>
                  <span>Suspend Company</span>
                </v-tooltip>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" color="error" class="ml-1" outlined small @click.prevent="
                      updateState(item.company.data.id, 'active')
                      ">
                      <v-icon small>fa fa-undo</v-icon>
                    </v-btn>
                  </template>
                  <span>Active Company</span>
                </v-tooltip>
                <v-tooltip bottom v-if="canCreateCustomer || canManagerAccessCustomer">
                  <template v-slot:activator="{ on }">
                    <v-btn v-if="loading" color="primary" loading></v-btn>
                    <v-btn v-else :disabled="item.company.data.state == 4" v-on="on" color="error" class="ml-1" outlined
                      small @click.prevent="processAccessUser(item.id)">
                      <v-icon small>fa-arrow-right</v-icon>
                    </v-btn>
                  </template>
                  <span>Access as admin</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import partnerAPI from '@/api/partner.js';
import companyAPI from '@/api/company.js';
import LayoutBasic from '@/layouts/PartnerHub';
import EditUser from '@/components/partner/users/Edit';
import CreateUser from '@/components/partner/users/Create';
import CloneCustomer from '@/components/partner/users/Clone';
import superAdminAPI from '@/api/superadmin.js';
import improveAPI from '@/api/superadmin.js';
import ImportCustomers from '@/components/partner/users/ImportCustomers';

export default {
  name: 'UsersPartner',
  components: {
    LayoutBasic,
  },
  data() {
    return {
      headers: [
        { text: 'Company', value: 'company_name', sortable: false },

        {
          text: '# Users',
          value: 'company.data.total_members',
          sortable: false,
        },
        {
          text: 'Email',
          value: 'email',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'company.data.state_description',
          sortable: false,
        },
        {
          text: '',
          value: 'id',
          sortable: false,
          align: 'end',
        },
      ],
      improvem: true,
      email: '',
      password: '',
      id: '',
      fullName: '',
      users: [],
      userdata: [],
      search: '',
      searchParams: '',
      pagination: {},
      options: {},
      loading: false,
      companyId: '',
      improve: [],
      edify: [],
      importUsers: '',
      confirmAccess: 'Are you sure you wish to access this user?',
      confirmDelete: 'Are you sure you wish to delete this user?',
      confirmDeleteForLiveUser:
        "As this customer is within their contract period you cannot delete them from the platform. By pressing 'Continue' it will delete the account at the end of their contract period. ",
      confirmRemoveContent: 'Are you sure you want to remove all courses?',
      successMessage: 'content successfully activated.',
      removeContentMessage: 'content now deactivated.',
      confirmUpdateCompanyState: 'Are you sure you wish to update state to ',
      successUpdateStateMessage: 'State has been updated Successfully',
      successReportMessage:
        'Your request to report will be processed and you will receive an email shortly with the link to the report.',
      status: [
        { id: 1, name: 'Free Trial' },
        { id: 2, name: 'Free Trial Expired' },
        { id: 3, name: 'Live' },
        { id: 4, name: 'Suspended Membership' },
        { id: 5, name: 'Free Trial Extended' },
      ],
      selectedStatus: "",
      timer: null,
      membershipPackages: [],
      showAlert: true, // Controls visibility
    };
  },
  computed: {
    computedHeaders() {
      let headers = [...this.headers];
      if (this.$globalConfig.APP_NAME == 'senso') {
        headers.splice(2, 0,
          { text: 'Compliance', value: 'improve', sortable: false, },
          { text: 'Safeguarding', value: 'edify', sortable: false, },
          { text: 'Lead Name', value: 'full_name', sortable: false, },
        );

        this.membershipPackages.forEach((membershipPackage, index) => {
          headers.splice(4 + index, 0, { text: membershipPackage.name, value: membershipPackage.id, sortable: false });
        });
      }
      if (this.$globalConfig.APP_NAME == 'partner') {
        headers.splice(2, 0,
          { text: 'Admin Name', value: 'full_name', sortable: false, },
        );
        headers.splice(5, 0,
          { text: 'Account Manager', value: 'manager_name', sortable: false, },
          { text: 'Renewal', value: 'company.data.renewal_at', sortable: false },
          { text: 'Invoiced', value: 'company.data.invoice_type', sortable: false },
        );
      }
      return headers;
    },
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    maxUsers: function () {
      return 500;
    },
    userLimit: function () {
      return this.serverItemsLength >= this.maxUsers ? true : false;
    },
    isPartnerLevel: function () {
      if (this.$store.getters.level == 4) {
        return true;
      } else {
        return false;
      }
    },
    canCreateCustomer: function () {
      if (
        this.$store.getters.level == 4 ||
        this.$store.getters.create_customer_permission == 1
      ) {
        return true;
      } else {
        return false;
      }
    },
    canManagerAccessCustomer: function () {
      if (this.$store.getters.level == 5) {
        return true;
      } else {
        return false;
      }
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
    importCustomer() {
      const permissions = this.$store.getters.user.permissions;
      if (typeof permissions != 'undefined')
        return permissions.includes('import-customers')
      else
        return false
    }
  },
  mounted() {
    this.setEventBus();
    this.loadSearch();
    if (this.$globalConfig.APP_NAME == 'senso') {
      this.getMembershipPackages();
    }
  },
  watch: {
    options: {
      handler() {
        this.getOwners();
      },
      deep: true,
    },
  },
  methods: {
    getOwners() {
      if (this.$store.getters.level == 2) {
        //this.$store.dispatch("logout").then(() => {
        //localStorage.removeItem('todos');
        //this.$router.push("/login");
        //});
      }
      this.loading = true;
      const is_partner = 0;
      partnerAPI
        .getOwners(
          this.params,
          this.searchParams,
          this.$store.getters.user.id + '&include=company&demo=yes',
          is_partner,
          this.selectedStatus
        )
        .then((resp) => {
          this.users = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
    getOwnersNew() {
      this.loading = true;
      partnerAPI
        .getOwners(
          this.params,
          this.searchParams,
          this.$store.getters.user.id + '&include=company&demo=yes'
        )
        .then((resp) => {
          this.users = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
    resetSearch() {
      this.options.page = 1;
      this.searchParams = '';
      this.search = '';
      this.getOwners();
      this.saveSearch();
    },
    addImproveContent(companyId) {
      this.loading = true;
      improveAPI
        .createEdifyImproveContent(this.$store.getters.user.id, companyId)
        .then(() => {
          this.$snotify.success('Compliance ' + this.successMessage);
          this.loading = false;
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
        })
        .catch((err) => {
          this.getOwners();
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
        });
    },
    addEdifyContent(companyId) {
      this.loading = true;
      improveAPI
        .createEdifyContent(this.$store.getters.user.id, companyId)
        .then(() => {
          this.$snotify.success('Safeguarding ' + this.successMessage);
          this.loading = false;
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
        })
        .catch((err) => {
          this.getOwners();
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
        });
    },
    loginToOwner(id) {
      this.$snotify.confirm(this.confirmAccess, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processAccessUser(toast, id),
          }
        ],
      });
    },
    processAccessUser(id) {
      this.loading = true;
      partnerAPI.getOwnersDetail(id).then((resp) => {
        this.userdata = resp.data.data;
        this.email = this.userdata[0].email;
        this.password = this.userdata[0].password;
        this.id = this.userdata[0].id;
        this.autologin();
        //this.loading = false;
      });
    },
    autologin: function () {
      this.$store
        .dispatch('autologin', {
          id: this.id,
        })
        .then(() => {
          localStorage.setItem('todos', this.$store.getters.user.id);
          this.getProfile();
        })
        .catch((err) => {
          this.valid = false;
          this.loading = false;
          this.messages = [];
          let errors = err.response.data.errors;
          let errMsg = err.response.data.message;
          if (errMsg) {
            this.errorMessage = errMsg;
            this.$snotify.error(errMsg);
          }
          if (errors) {
            for (let field in errors) {
              this.messages[field] = errors[field];
            }
          }
        });
    },
    getProfile() {
      this.$store
        .dispatch('profile')
        .then((resp) => {
          switch (this.$store.getters.level) {
            case 2:
              this.$router.push('/admin/users');
              //this.$router.push("/playlists");
              break;
            case 4:
              this.$router.push('/partner/users');
              break;
            default:
              this.$router.push('/courses');
              break;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    setEventBus() {
      EventBus.$on('USERS_UPDATED', (payload) => {
        // this.params = payload;
        this.getOwners();
      });
      EventBus.$on('USERS_ADDED', (payload) => {
        // this.params = payload;
        this.getOwners();
      });
      EventBus.$on('closePanel', (payload) => {
        this.getOwners();
      });
    },
    applySearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.options.page = 1;
        this.searchParams =
          '&search=company.company_name:' +
          this.search;
        this.getOwners();
        this.saveSearch();
      }, 1000);
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditUser,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showDetailsPanel(id) {
      this.$showPanel({
        component: ViewDetails,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
    showCreatePanel() {
      this.$showPanel({
        component: CreateUser,
        props: {
          params: this.params,
          id: this.$store.getters.user.id,
        },
        openOn: 'right',
      });
    },
    showUserImportPanel() {
      this.$showPanel({
        component: ImportUser,
        props: {
          params: this.params,
        },
        openOn: 'right',
      });
    },
    changeStatus(id, user_id) {
      this.$snotify.confirm(this.confirmChangeStatus, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processChangeStatus(toast, id, user_id),
          }
        ],
      });
    },
    processChangeStatus(toast, id, user_id) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      companyAPI.updateCompanyState(id, user_id, 'maunally').then((resp) => {
        this.getOwners();
        this.loading = false;
      });
    },
    showCreateClonePanel(id, companyId) {
      this.$showPanel({
        component: CloneCustomer,
        props: {
          id: id,
          companyId: companyId
        },
        openOn: 'right',
      });
    },
    removeContent(id, userId, contentType, packageId = '', packageName = '') {
      this.$snotify.confirm(this.confirmRemoveContent, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button', action: (toast) => this.removeToast(toast) },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) =>
              this.processRemoveContent(toast, id, userId, contentType, packageId, packageName),
          },

        ],
      });
    },
    removeToast(toast) {
      this.$snotify.remove(toast.id);
      this.getOwners();
    },
    processRemoveContent(toast, id, userId, contentType, packageId, packageName) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      superAdminAPI
        .removeEdifyImproveContent(id, userId, contentType, packageId)
        .then((resp) => {
          this.getOwners();
          this.loading = false;
          var successMessage = '';
          if (packageName == '') {
            successMessage = contentType
              ? 'Safeguarding ' + this.removeContentMessage
              : 'Compliance ' + this.removeContentMessage;
          } else {
            successMessage = packageName + ' Package ' + this.removeContentMessage;
          }
          this.$snotify.success(successMessage);
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
        });
    },
    updateState(id, state = '') {
      var confirmUpdateCompanyState =
        this.confirmUpdateCompanyState + state + '?';
      this.$snotify.confirm(confirmUpdateCompanyState, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processUpdateCompanyState(toast, id, state),
          }
        ],
      });
    },
    processUpdateCompanyState(toast, id, state) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      companyAPI.updateCompanyState(id, '', state).then(() => {
        this.$snotify.success(this.successUpdateStateMessage);
        this.getOwners();
        this.loading = false;
        setTimeout(() => {
          this.$gf.removeBackdrop();
        }, 300);
      });
    },
    processGetFullPlatformReport(companyId, partnerId) {
      this.loading = true;
      companyAPI.getFullPlatformReport(companyId, partnerId).then(() => {
        this.$snotify.success(this.successReportMessage);
        this.loading = false;
        setTimeout(() => {
          this.$gf.removeBackdrop();
        }, 300);
      }).catch((err) => {
        // Never leave the page stuck on the loading spinner if the request fails.
        this.loading = false;
        setTimeout(() => {
          this.$gf.removeBackdrop();
        }, 300);
        const status = err && err.response ? err.response.status : null;
        if (status === 403) {
          this.$snotify.error(
            'The Full Platform Report can only be run from the Partner admin account.'
          );
        } else {
          this.$snotify.error(
            'Sorry, the Full Platform Report could not be generated. Please try again or contact support.'
          );
        }
      });
    },
    FilterByStatus(status) {
      this.options.page = 1;
      if ((typeof status != 'undefined') && status !== null)
        this.selectedStatus = '&state=' + status;
      else
        this.selectedStatus = '';

      this.getOwners();
    },
    saveSearch() {
      // Save search value to localStorage
      if (this.search && this.search.length > 0) {
        localStorage.setItem('search-customer', this.search);
      } else {
        localStorage.removeItem('search-customer');
      }
    },
    loadSearch() {
      // Load search value from localStorage
      const savedSearch = localStorage.getItem('search-customer');
      if (savedSearch !== null) {
        this.search = savedSearch;
        this.searchParams =
          '&search=first_name:' +
          this.search +
          ';last_name:' +
          this.search +
          ';customer:' +
          this.search;
      }
    },
    getMembershipPackages() {
      improveAPI.getMembershipPackages().then(response => {
        this.membershipPackages = response.data.data;
      });
    },
    addMembershipContent(id, companyId, packageId, packageName) {
      this.loading = true;
      improveAPI
        .createMembershipContent(this.$store.getters.user.id, id, companyId, packageId)
        .then(() => {
          this.$snotify.success(packageName + ' Package ' + this.successMessage);
          this.loading = false;
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
        })
        .catch((err) => {
          this.getCompanies();
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
        });
    },
    showCustomerImportPanel() {
      this.$showPanel({
        component: ImportCustomers,
        openOn: 'right',
      });
    },

    redirectTo(url){
      this.$router.push(url)
    },
  },
  beforeDestroy() {
    EventBus.$off('USERS_UPDATED');
    EventBus.$off('USERS_ADDED');
    EventBus.$off('closePanel');
  },
};
</script>
<style type="text/css">
.v-input--selection-controls {
  padding-top: 6px !important;
  margin-top: 0px !important;
}

.addcustomer-button-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 1em;
}

.custom-border {
  border: 2px solid #FFDCA5 !important;
}

@media (max-width: 960px) {
  .addcustomer-button-wrapper {
    justify-content: start;
  }
}
</style>
